import React from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';

import { Form } from 'common/components';
import Validated from 'components/util/Validated';

import { createRoute } from 'lib/util';

const AssetLevelForm = ({
  company,
  errors,
  handleSubmit,
  handleValueChange,
  isSaving,
  isSubmitted,
  subcompany,
  roles = [],
  handleGroupChange, //Groups
  handleCustomFieldChange, //Groups
  groups, //Groups
  t,
  values,
}) => {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
    >
      <div className="col-md-12 mt-3">
        <div className="row align-items-center">
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Form.FieldInput
              error={(isSubmitted && errors.key) || {}}
              name={'key'}
              label={t('asset_level.fields.key')}
              handleChange={handleValueChange}
              t={t}
              value={values.key}
            />
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Form.FieldInput
              error={(isSubmitted && errors.name) || {}}
              name={'name'}
              label={t('asset_level.fields.name')}
              handleChange={handleValueChange}
              t={t}
              value={values.name}
            />
          </div>

          <div className="col-sm-6 col-md-4 col-lg-3">
            <Form.FieldInput
              type="number"
              error={(isSubmitted && errors.max_time) || {}}
              name={'max_time'}
              label={t('asset_level.fields.max_time')}
              handleChange={handleValueChange}
              t={t}
              value={values.max_time}
            />
          </div>

          <div className="col-sm-6 col-md-4 col-lg-3">
            <Form.Checkbox
              error={(isSubmitted && errors.message_required) || {}}
              className="icheckbox_flat-blue"
              name={'message_required'}
              label={t('asset_level.fields.message_required')}
              onChange={handleValueChange}
              t={t}
              checked={values.message_required}
            />
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Form.Checkbox
              error={(isSubmitted && errors.can_withdrawn) || {}}
              className="icheckbox_flat-blue"
              name={'can_withdrawn'}
              label={t('asset_level.fields.can_withdrawn')}
              onChange={handleValueChange}
              t={t}
              checked={values.can_withdrawn}
            />
          </div>

          <div className="col-sm-6 col-md-4 col-lg-3">
            <Form.FieldSelect
              error={(isSubmitted && errors.role_to_acept) || {}}
              name={'role_to_acept'}
              label={t('asset_level.fields.role_to_acept')}
              handleChange={handleValueChange}
              t={t}
              value={values.role_to_acept}
            >
              {roles.map((role) => (
                <option key={role.id} value={role.id}>
                  {role.key} - {role.name}
                </option>
              ))}
            </Form.FieldSelect>
          </div>
          {/* Groups */}
          {/* <Form.CustomFields
            errors={errors}
            handleCustomFieldChange={handleCustomFieldChange}
            handleGroupChange={handleGroupChange}
            isSubmitted={isSubmitted}
            t={t}
            values={values}
            groups={groups}
          >
          </Form.CustomFields> */}
          {/* Groups */}
        </div>
      </div>

      <div className="col-md-12 mt-3">
        <Form.Button
          type={'submit'}
          text={t('actions.save')}
          isLoading={isSaving}
          disabled={isSaving}
          extraClassName={'pull-right btn-xs-block'}
        />

        <Form.Link
          to={createRoute(company.id, subcompany.id, `asset_level`)}
          className={classnames('btn btn-secondary pull-right mr-3', {
            disabled: isSaving,
          })}
        >
          {t('actions.cancel')}
        </Form.Link>
        <div className="clearfix" />
      </div>
    </form>
  );
};

export default Validated({
  type: 'object',
  properties: {
    key: {
      type: 'string',
      minLength: 1,
    },
    name: {
      type: 'string',
      minLength: 1,
    },
    max_time: {
      type: 'number',
      minLength: 1,
    },
    message_required: {
      type: 'boolean',
    },
    can_withdrawn: {
      type: 'boolean',
    },
    role_to_acept: {
      type: 'string',
    },
  },
  required: ['key', 'name', 'max_time'],
})(translate()(AssetLevelForm));



// WEBPACK FOOTER //
// src/modules/secured/modules/asset_level/components/form/AssetLevelForm.js